import {
	axios
} from '@/utils/request'
import {
	downLoadXlxs
} from '@/utils/index'


// 品类清单列表
export function getCategoryList(parameter) {
	return axios({
		url: '/daily/category/list',
		method: 'get',
		params: parameter
	})
}
// 我的考试列表
export function examlis(parameter) {
	return axios({
		url: '/training/training/exam/list',
		method: 'get',
		params: parameter
	})
}
// 查看错题
export function examlis_err(parameter) {
	return axios({
		url: '/training/tra_question/err',
		method: 'get',
		params: parameter
	})
}
//题库列表
export function textInfoList(parameter) {
	return axios({
		url: '/training/tra_question/info_list',
		method: 'get',
		params: parameter
	})
}

// 新增品类
export function saveCategory(parameter) {
	return axios({
		url: '/daily/category/info',
		method: 'post',
		data: parameter
	})
}
// export function saveCategory(parameter) {
// 	return axios({
// 		url: '/daily/category/saveCategory',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// 生成试卷
export function generate(parameter) {
	return axios({
		url: '/training/tra_question/generate',
		method: 'get',
		params: parameter
	})
}
// 编辑品类清单
// export function editCategory(parameter) {
// 	return axios({
// 		url: '/daily/category/editCategory',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// 查询题目详情
export function generate_info(parameter) {
	return axios({
		url: '/training/tra_question/info',
		method: 'get',
		params: parameter
	})
}
//关联物品明细
// export function getCategoryDetil(parameter) {
// 	return axios({
// 		url: '/daily/category/getCategoryDetil',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// 提交试卷
export function generate_submit(parameter) {
	return axios({
		url: '/training/tra_question/submit',
		method: 'post',
		data: parameter
	})
}
// 查询本部门全部课程信息列表
export function training_lis(parameter) {
	return axios({
		url: '/training/training/user/list',
		method: 'get',
		params: parameter
	})
}
// 查询课程类型列表  1：我的课程类型列表；0：本部门课程类型列表;必填
export function training_getTypeList(parameter) {
	return axios({
		url: '/training/training/user/getTypeList',
		method: 'get',
		params: parameter
	})
}
// 获取我的学时
export function getMyHours(parameter) {
	return axios({
		url: '/training/training/user/getMyHours',
		method: 'post',
		data: parameter
	})
}
// 查询我已选择课程信息列表
export function training_mylis(parameter) {
	return axios({
		url: '/training/training/user/myList',
		method: 'get',
		params: parameter
	})
}

//品类名称
// export function categoryNameList(parameter) {
// 	return axios({
// 		url: '/daily/category/getCategoryIdAndNameList',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// 删除我的课程（线上自动获取userId）
export function training_my_del(parameter) {
	return axios({
		url: '/training/training/user/'+parameter.id,
		method: 'delete',
		data: parameter
	})
}
// 加入课表
export function training_addMyExam(parameter) {
	return axios({
		url: '/training/training/user/addMyExam',
		method: 'POST',
		data: parameter
	})
}
// 更新我的课程进度以及状态
export function training_up(parameter) {
	return axios({
		url: '/training/training/user',
		method: 'PUT',
		data: parameter
	})
}
// 获取视频信息
export function training_video_log(parameter) {
	return axios({
		url: '/training/tra_question/video_log',
		method: 'get',
		params: parameter
	})
}
// 保存视频观看记录
export function training_up_video_log(parameter) {
	return axios({
		url: '/training/tra_question/video_log',
		method: 'post',
		data: parameter
	})
}
export function editCategory(parameter) {
	return axios({
		url: '/daily/category/info',
		method: 'put',
		data: parameter
	})
}
//关联物品明细
export function getCategoryDetil(parameter) {
	return axios({
		url: '/daily/category/detail',
		method: 'get',
		params: parameter
	})
}
//品类名称
export function categoryNameList(parameter) {
	return axios({
		url: '/daily/category/getCategoryIdAndNameList',
		method: 'get',
		params: parameter
	})
}
